import { Languages } from '../types';

export const CREATE_CONTACT = 'create-contact';

export const FOOTER_LINKS = {
  FACEBOOK: 'https://www.facebook.com/iFood/',
  TWITTER: 'https://twitter.com/ifood',
  INSTAGRAM: 'https://www.instagram.com/ifoodbrasil/',
  YOUTUBE: 'https://www.youtube.com/user/ifooddelivery',

  CONTACT: 'https://www.ifood.com.br/ajuda',
  JOBS: 'https://www.ifood.com.br/carreiras',
  TERMS: 'https://www.ifood.com.br/termos',
  CODE_OF_CONDUCT: 'https://www.ifood.com.br/codigo-de-conduta',
  PRIVACY: 'https://www.ifood.com.br/privacidade',
  MEDIUM: 'https://medium.com/ifood-developer',
};

export const LANGUAGES_OPTIONS = [Languages.PT_BR, Languages.EN_US, Languages.ES_CO];
